import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Paper, Container } from '@mui/material'
import ProgressButton from '../../Utils/ProgressButton'
import { entityTextField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { ProductMeasurementTypeDetailState } from '../../../reducers/product/productMeasurementTypeDetail'
import { upsertProductMeasurementType } from '../../../actions/product/productMeasurementTypeUpsert'
import ProductMeasurementType from '../../../models/ProductMeasurementType'
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { fetchProductMeasurementType } from '../../../actions/product/productMeasurementTypeDetail'
import { BackButton } from '../../Utils/BackButton'
import Selector from '../../Selector'
import { isNil } from 'ramda'

interface Props {
  productMeasurementType: ProductMeasurementTypeDetailState
}

const empty: ProductMeasurementType = {
  id: null,
  description: '',
  ownerId: 0,
  ownerName: '',
  active: true
}

const ProductMeasurementTypeUpsert: React.FC<Props> = ({ productMeasurementType }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [productMeasurementTypeInfo, setProductMeasurementTypeInfo] = useState<ProductMeasurementType>(productMeasurementType.productMeasurementType || empty)
  const { t } = useTranslation('product')
  const dispatch = useDispatch()
  const params = useParams<{ productMeasurementTypeId: string }>()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (params.productMeasurementTypeId) {
      dispatch(fetchProductMeasurementType(params.productMeasurementTypeId))
    }
  }, [dispatch, params.productMeasurementTypeId])


  const change = (newProductMeasurementTypeInfo: ProductMeasurementType) => {
    setProductMeasurementTypeInfo(newProductMeasurementTypeInfo)
    setChanged(true)
  }

  const changeProductMeasurementType = async (event: FormEvent) => {
    event.preventDefault()
    try {
      await dispatch(upsertProductMeasurementType(productMeasurementTypeInfo))
      setChanged(false)
      if (location.state)
        (location.state as any).update = !(location.state as any).update
      history.goBack()
    }
    catch {
    }
  }

  useEffect(() => {
    if (productMeasurementType.productMeasurementType) {
      setProductMeasurementTypeInfo(params.productMeasurementTypeId ? productMeasurementType.productMeasurementType : empty)
    }
  }, [productMeasurementType.productMeasurementType, params.productMeasurementTypeId])

  const ProductMeasurementTypeInfoField = useMemo(() => entityTextField(change), [])

  return (
    <Container>
      <Paper style={{ borderRadius: "10px", margin: "10px" }}>
        <ISTableTitle title={t('measurementTypes')} />
        <Paper style={{ padding: "10px" }}>
          <form onSubmit={changeProductMeasurementType}>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductMeasurementTypeInfoField
                key="description"
                variant="outlined"
                label={t("description")}
                entity={productMeasurementTypeInfo}
                attr="description"
                size="medium"
              />
              <Selector
                key="active"
                label={t("active")}
                style={{ width: "100%" }}
                value={isNil(productMeasurementTypeInfo.active) ? "" : Boolean(productMeasurementTypeInfo.active)}
                textAdapter={(_value) => Boolean(_value) ? t("yes") : t("no")}
                menuItems={[true, false]}
              />
            </Stack>
            <Stack display="flex" flexDirection='row' justifyContent="space-between">
              <BackButton />
              <ProgressButton state={productMeasurementType} disabled={!changed}>
                {t('save')}
              </ProgressButton>
            </Stack>
          </form>
        </Paper>
      </Paper>
    </Container>

  )
}

const mapStateToProps = (state: AppState) => ({
  productMeasurementType: state.productMeasurementTypeDetail
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(ProductMeasurementTypeUpsert)
